// Copyright 2019 Participatory Culture Foundation, All Rights Reserved

var $ = require('jquery');

$.behaviors('.hideOnInputValue', hideOnInputValue);

function hideOnInputValue(container) {
    container = $(container);
    var form = container.closest('form');

    function checkInput(input) {
        if(shouldHide(container, input)) {
            container.hide();
        } else {
            container.show();
        }
    }

    checkInput($('[name=' + container.data('name') + ']', form));
    form.on('change', function(evt) {
        if(evt.target.name == container.data('name')) {
            checkInput($(evt.target));
        }
    });
}

function shouldHide(container, input) {
    if(container.data('hideIf') && input.val() == container.data('hideIf')) {
        return true;
    }
    return false;
}
